export const KEYBOARD_ACTIONS = {
  TAB: "Tab",
  ENTER: "Enter",
  CONTROL: "Control",
  ESCAPE: "Escape",
  ARROW_UP: "ArrowUp",
  ARROW_DOWN: "ArrowDown",
}
